import { MarginApiResponse } from '@store/refinanciamento/marginAcceptResult/types'

import { BaseServices, HttpMethod, TResponseType } from './base'
import { BridgeService } from './bridge'

export interface MarginApiParams {
  convenioName: string
  accessToken?: string
}

export default ({
  convenioName,
  accessToken,
}: MarginApiParams): Promise<TResponseType<MarginApiResponse>> => {
  const pathname = `${process.env.REACT_APP_MARGIN_ACCEPT_RESULT}/${convenioName}/result`
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return BaseServices.request<MarginApiResponse>({
    headers,
    pathname,
    method,
    host,
  })
}
